"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
require("vue-virtual-scroller/dist/vue-virtual-scroller.css");
var _vueVirtualScroller2 = require("vue-virtual-scroller");
var _default = exports.default = {
  name: 'VirtualScrollListToSelect',
  // 虚拟滚动列表选择组件（支持多选、单选） - 基于checkbox实现多选、radio实现单选功能
  components: {
    RecycleScroller: _vueVirtualScroller2.RecycleScroller
  },
  props: {
    // 默认选中的值，单选也传数组，组件内部已做兼容转换
    defaultCheckedKeys: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 用于选择的数组
    dataSource: {
      type: Array,
      default: () => {
        return undefined;
      }
    },
    // 替换 checkbox 中的 title，value，key
    replaceFields: {
      type: Object,
      default: () => {
        return {
          title: 'title',
          value: 'value',
          key: 'key'
        };
      }
    },
    // 是否支持多选，false 为单选
    multiple: {
      type: Boolean,
      default: true
    },
    // 用于搜索的字段
    searchFiled: {
      type: String,
      default: 'title'
    },
    searchPlaceholder: {
      type: String,
      default: '请输入关键字进行搜索'
    },
    showAlert: {
      type: Boolean,
      default: true
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    // 虚拟滚动组件的属性配置
    scrollerProps: {
      type: Object,
      default: () => {
        return {
          itemSize: 30
        };
      }
    },
    scrollHeight: {
      type: String,
      default: '70vh'
    },
    tooltipPlacement: {
      type: String,
      default: 'right'
    },
    // 以标签的形式显示已选中的数据
    showTag: {
      type: Boolean,
      default: false
    },
    // 显示的最大tag数量
    maxTagCount: {
      type: Number,
      default: 20
    },
    // 最大显示的字符长度，超过显示省略号
    maxTagTextCount: {
      type: Number,
      default: 15
    }
  },
  data() {
    return {
      keyword: '',
      allList: [],
      // 全部列表
      targetList: [],
      // 符合搜索条件的列表
      checkedValueList: [],
      // 当前搜索条件下已选中的value数组
      allCheckedValueList: [],
      // 全部已选中value数组
      checkAll: false
    };
  },
  computed: {
    targetListKeys() {
      return this.targetList.map(item => item[this.replaceFields.value]);
    },
    allKeys() {
      return this.allList.map(item => item[this.replaceFields.value]);
    },
    indeterminate() {
      return this.allCheckedValueList.length > 0 && this.allCheckedValueList.length !== this.allList.length;
    },
    allCheckedList() {
      return this.allList.filter(item => this.allCheckedValueList.includes(item[this.replaceFields.value]));
    },
    showedCheckedList() {
      if (this.maxTagCount === 0) {
        return this.allCheckedList;
      }
      return this.allCheckedList.slice(0, this.maxTagCount);
    },
    count() {
      return this.allCheckedValueList.length - this.maxTagCount;
    }
  },
  watch: {
    dataSource: {
      handler(val) {
        if (val) {
          this.allList = [...val];
          this.onSearchInputChange({}, false);
          this.fillDefaultCheckedKeys();
        }
      },
      immediate: true,
      deep: true
    },
    defaultCheckedKeys: {
      handler(val) {
        this.fillDefaultCheckedKeys();
      },
      immediate: true,
      deep: true
    },
    allCheckedValueList: {
      handler(val) {
        this.$emit('change', val, this.allCheckedList);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    fillDefaultCheckedKeys() {
      // 回填默认值 取交集，可过滤掉不存在的节点
      const _intersections = _.intersection(this.defaultCheckedKeys, this.allKeys);
      if (_intersections.length > 0) {
        this.allCheckedValueList = _intersections;
        this.checkedValueList = this.multiple ? _intersections : _intersections.toString();
      }
    },
    handleTagClose(tag) {
      const _value = tag[this.replaceFields.value];
      this.allCheckedValueList = this.allCheckedValueList.filter(item => item !== _value);
      this.checkedValueList = this.multiple ? this.checkedValueList.filter(item => item !== _value) : [];
    },
    // 全选
    onCheckAllChange(e) {
      if (e.target.checked) {
        this.allCheckedValueList = [...new Set([...this.allCheckedValueList, ...this.targetListKeys])];
      } else {
        this.allCheckedValueList = _.difference(this.allCheckedValueList, this.targetListKeys);
      }
      this.checkedValueList = [...this.allCheckedValueList];
      this.checkAll = e.target.checked;
    },
    // 单个选择
    onCheckChange(e) {
      const _index = this.allCheckedValueList.findIndex(item => item === e.target.value);
      if (_index === -1) {
        this.allCheckedValueList = [...new Set([...this.allCheckedValueList, e.target.value])];
      } else {
        this.allCheckedValueList.splice(_index, 1);
      }
    },
    onRadioChange(e) {
      this.allCheckedValueList = [e.target.value];
    },
    onSearchInputChange: _.debounce(function (e, refresh = true) {
      // eslint-disable-next-line no-invalid-this
      const {
        allList,
        searchFiled,
        replaceFields
      } = this;
      // eslint-disable-next-line no-invalid-this
      this.targetList = _.cloneDeep(allList).filter(item => {
        const _field = item[searchFiled] ? searchFiled : replaceFields.title;
        // eslint-disable-next-line no-invalid-this
        return item[_field].indexOf(this.keyword.trim()) !== -1;
      });
      if (refresh) {
        // eslint-disable-next-line no-invalid-this
        this.checkAll = false;
      }
    }, 300)
  }
};